__turbopack_context__.v({
  "buttonBox": "styles-module-scss-module__kUuDda__buttonBox",
  "icon": "styles-module-scss-module__kUuDda__icon",
  "root": "styles-module-scss-module__kUuDda__root",
  "text": "styles-module-scss-module__kUuDda__text",
});
